import React from "react";
import { legal, brand } from "../mock";
import { Section, Footer } from "./Landing";
import { Button } from "../components/ui/button";
import { useSEO, SEO_PRESETS } from "@/hooks/useSEO";

const LegalHeader = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-white/80 backdrop-blur-xl supports-[backdrop-filter]:bg-white/60 shadow-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <img 
              src="/images/logo-klartech.png" 
              alt="Klartech Müritz Logo" 
              className="h-12 w-auto object-contain transition-transform hover:scale-105"
            />
            <div className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-green-500 animate-pulse ring-2 ring-white"></div>
          </div>
        </div>
        <nav className="flex items-center gap-8">
          <Button
            onClick={() => window.location.href = '/'}
            className="relative rounded-xl bg-gradient-to-r from-primary to-blue-600 px-6 py-2.5 text-white shadow-lg transition-all hover:shadow-xl hover:scale-105 group overflow-hidden"
          >
            <span className="relative z-10 font-semibold">← Zur Startseite</span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-primary opacity-0 transition-opacity group-hover:opacity-100"></div>
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default function Impressum() {
  // SEO für Impressum
  useSEO(SEO_PRESETS.impressum);
  
  const imp = legal.impressum;

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <LegalHeader />
      <Section id="impressum" className="pt-10">
        <h1 className="text-3xl font-extrabold tracking-tight">Impressum</h1>
        <div className="mt-6 grid gap-1 text-slate-700">
          <div className="font-semibold">{imp.company}</div>
          <div>{imp.name}</div>
          {imp.address.map((a) => (
            <div key={a}>{a}</div>
          ))}
          <div>Tel: {imp.phone}</div>
          <div>E-Mail: {imp.email}</div>
        </div>

        <div className="prose prose-slate mt-10 max-w-none">
          <h2>Disclaimer - rechtliche Hinweise</h2>
          <h3>Auskunfts- und Widerrufsrecht</h3>
          <p>
            Sie haben jederzeit das Recht, sich unentgeltlich und unverzüglich über die zu Ihrer Person erhobenen Daten zu erkundigen.
            Ebenfalls können Sie Ihre Zustimmung zur Verwendung Ihrer angegebenen persönlichen Daten mit Wirkung für die Zukunft widerrufen.
          </p>
          <h3>Weitere Hinweise</h3>
          {imp.notes.map((n) => (
            <p key={n}>{n}</p>
          ))}
        </div>
      </Section>
      <Footer />
    </div>
  );
}
